/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const purchaseOrderLines = sqliteTable('purchase_order_lines', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  purchase_order_id: text('purchase_order_id'),
  inventory_item_id: text('inventory_item_id'),
  item_name_snapshot: text('item_name_snapshot'),
  sku_snapshot: text('sku_snapshot'),
  unit_snapshot: text('unit_snapshot'),
  quantity_ordered: real('quantity_ordered'),
  bonus_quantity: real('bonus_quantity'),
  rate: real('rate'),
  amount: real('amount'),
  remarks: text('remarks'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
